<template>
  <div class="order-details" style="padding-top: 1rem;">
    <!--<navTitle title="订单详情" path='/order/list/0' color="#fff"></navTitle>-->
    <navTitle :title="$router.app._route.query.ti ? $router.app._route.query.ti : $t('message.my_order.detail_title')"
      path="/order/list/0" color="#fff"></navTitle>

    <!-- 给header上与data上加on为退款订单-->
    <div class="header  acea-row row-middle"
      style="background: #FBFBFB;color: #333" :class="refundOrder ? 'on' : ''">
      <!--<div class="pictrue" v-if="!refundOrder">-->
      <!--<img :src="orderInfo.status_pic" />-->
      <!--</div>-->
      <div class="data" :class="refundOrder ? 'on' : ''">
        <div class="state">{{ orderInfo._status._msg }}</div>
        <div>
          {{ orderInfo.add_time_y }}<span class="time">{{ orderInfo.add_time_h }}</span>
        </div>
      </div>
    </div>
    <template v-if="!refundOrder">
      <!--<div class="nav">-->
      <!--<div class="navCon acea-row row-between-wrapper">-->
      <!--<div :class="{ on: status.type === 0 || status.type === 9 }">-->
      <!--待付款-->
      <!--</div>-->
      <!--<div-->
      <!--:class="{ on: status.type === 1 }"-->
      <!--v-if="orderInfo.shipping_type === 2"-->
      <!--&gt;-->
      <!--待核销-->
      <!--</div>-->
      <!--<div :class="{ on: status.type === 1 }" v-else>待发货</div>-->
      <!--<div-->
      <!--:class="{ on: status.type === 2 }"-->
      <!--v-if="orderInfo.shipping_type === 1"-->
      <!--&gt;-->
      <!--待收货-->
      <!--</div>-->
      <!--<div :class="{ on: status.type === 3 }">待评价</div>-->
      <!--<div :class="{ on: status.type === 4 }">已完成</div>-->
      <!--</div>-->
      <!--<div class="progress acea-row row-between-wrapper">-->
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="[-->
      <!--status.type === 0 || status.type === 9-->
      <!--? 'icon-webicon318'-->
      <!--: 'icon-yuandianxiao',-->
      <!--status.type >= 0 ? 'font-color-red' : ''-->
      <!--]"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="line"-->
      <!--:class="{ 'bg-color-red': status.type > 0 && status.type != 9 }"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="[-->
      <!--status.type === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',-->
      <!--status.type >= 1 && status.type != 6 && status.type != 9-->
      <!--? 'font-color-red'-->
      <!--: ''-->
      <!--]"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="line"-->
      <!--:class="{-->
      <!--'bg-color-red':-->
      <!--status.type > 1 && status.type != 6 && status.type != 9-->
      <!--}"-->
      <!--v-if="orderInfo.shipping_type === 1"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="[-->
      <!--status.type === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',-->
      <!--status.type >= 2 && status.type != 6 && status.type != 9-->
      <!--? 'font-color-red'-->
      <!--: ''-->
      <!--]"-->
      <!--v-if="orderInfo.shipping_type === 1"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="line"-->
      <!--:class="{-->
      <!--'bg-color-red':-->
      <!--status.type > 2 && status.type != 6 && status.type != 9-->
      <!--}"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="[-->
      <!--status.type === 3 ? 'icon-webicon318' : 'icon-yuandianxiao',-->
      <!--status.type >= 3 && status.type != 6 && status.type != 9-->
      <!--? 'font-color-red'-->
      <!--: ''-->
      <!--]"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="line"-->
      <!--:class="{-->
      <!--'bg-color-red':-->
      <!--status.type > 3 && status.type != 6 && status.type != 9-->
      <!--}"-->
      <!--&gt;</div>-->
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="[-->
      <!--status.type == 4 ? 'icon-webicon318' : 'icon-yuandianxiao',-->
      <!--status.type >= 4 && status.type != 6 && status.type != 9-->
      <!--? 'font-color-red'-->
      <!--: ''-->
      <!--]"-->
      <!--&gt;</div>-->
      <!--</div>-->
      <!--</div>-->

      <!--无用代码-->
      <!--<div-->
      <!--class="writeOff"-->
      <!--v-if="orderInfo.shipping_type === 2 && orderInfo.paid === 1"-->
      <!--&gt;-->
      <!--<div class="title">核销信息</div>-->
      <!--<div class="grayBg">-->
      <!--<div class="pictrue"><img :src="orderInfo.code" /></div>-->
      <!--</div>-->
      <!--<div class="gear"><img src="@assets/images/writeOff.jpg" /></div>-->
      <!--<div class="num">{{ orderInfo._verify_code }}</div>-->
      <!--<div class="rules">-->
      <!--<div class="item">-->
      <!--<div class="rulesTitle acea-row row-middle">-->
      <!--<span class="iconfont icon-shijian"></span>核销时间-->
      <!--</div>-->
      <!--<div class="info">-->
      <!--每日:<span class="time">{{ system_store.day_time }}</span>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="item">-->
      <!--<div class="rulesTitle acea-row row-middle">-->
      <!--<span class="iconfont icon-shuoming1"></span>使用说明-->
      <!--</div>-->
      <!--<div class="info">可将二维码出示给店员扫描或提供数字核销码</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div-->
      <!--class="map acea-row row-between-wrapper"-->
      <!--v-if="orderInfo.shipping_type === 2 && orderInfo.paid === 1"-->
      <!--&gt;-->
      <!--<div>自提地址信息</div>-->
      <!--<div-->
      <!--class="place cart-color acea-row row-center-wrapper"-->
      <!--@click="showChang"-->
      <!--&gt;-->
      <!--<span class="iconfont icon-weizhi"></span>查看位置-->
      <!--</div>-->
      <!--</div>-->

      <div v-if="orderInfo.real_name != ''">
        <div class="address" v-if="orderInfo.shipping_type === 1">
          <div class="name">
            {{ orderInfo.real_name }}<span class="phone">{{ orderInfo.user_phone }}</span>
          </div>
          <div>{{ orderInfo.user_address }}</div>
        </div>
        <!--其他模式-->
        <!--<div class="address" v-else>-->
        <!--<div class="name">-->
        <!--{{ system_store.name-->
        <!--}}<span class="phone">{{ system_store.phone }}</span>-->
        <!--<a-->
        <!--class="iconfont icon-tonghua font-color-red"-->
        <!--:href="'tel:' + system_store.phone"-->
        <!--&gt;</a>-->
        <!--</div>-->
        <!--<div>{{ system_store._detailed_address }}</div>-->
        <!--</div>-->
        <div class="line" v-if="orderInfo.shipping_type === 1">
          <img src="@assets/images/line.jpg" />
        </div>
      </div>
    </template>
    <OrderGoods
      :evaluate="status.type || 0"
      :cartInfo="orderInfo.cartInfo || []"
      :gameState="orderInfo.game_state"
    ></OrderGoods>
    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_order_no')}}:</div>
        <div class="conter acea-row row-middle row-right">
          {{ orderInfo.order_id }}<span
            class="copy copy-data"
            :data-clipboard-text="orderInfo.order_id"
            >{{$t('message.my_order.detail_copy')}}</span>
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_order_time')}}:</div>
        <div class="conter" v-if="orderInfo.add_time_y">
          {{ orderInfo.add_time_y + " " + orderInfo.add_time_h }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_type_order')}}:</div>
        <div class="conter">
          {{ orderTypeName }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_status_payment')}}:</div>
        <div class="conter">{{ orderInfo.paid ? $t('message.my_order.detail_have_pay') : $t('message.my_order.detail_did_pay') }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_promotion_status')}}:</div>
        <div class="conter">{{ orderInfo._game_state }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_promotion_period')}}:</div>
        <div class="conter">{{ orderInfo.game_lottery_num }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_promotion_games')}}:</div>
        <div class="conter">{{ orderInfo._game_type }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_opening_time')}}:</div>
        <div class="conter">{{ orderInfo._game_open_time }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_my_choice')}}:</div>
        <div class="conter" style="white-space: normal;word-break: break-all;">{{ orderInfo.game_guess }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.game_state != 1">
        <div>{{$t('message.my_order.detail_lottery_numbers')}}:</div>
        <div class="conter">{{ gameOpenData.number }}</div>
      </div>

      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_payment_method')}}:</div>
        <div class="conter">{{ orderInfo._status._payType }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.mark">
        <div>Customer message:</div>
        <div class="conter">{{ orderInfo.mark }}</div>
      </div>
    </div>

    <div v-if="orderInfo.status != 0">
      <div class="wrapper" v-if="orderInfo.delivery_type === 'express'">
        <div class="item acea-row row-between">
          <div>Delivery method:</div>
          <div class="conter">
            Courier
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>Delivery company:</div>
          <div class="conter">{{ orderInfo.delivery_name || "" }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>Tracking number:</div>
          <div class="conter">{{ orderInfo.delivery_id || "" }}</div>
        </div>
      </div>

      <div class="wrapper" v-else>
        <div class="item acea-row row-between">
          <div>Delivery method:</div>
          <div class="conter">
            delivery
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>Delivery man:</div>
          <div class="conter">{{ orderInfo.delivery_name || "" }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>Delivery contact:</div>
          <div class="conter acea-row row-middle row-right">
            {{ orderInfo.delivery_id || "" }}<span class="copy">Call</span>
          </div>
        </div>
      </div>
    </div>
    <!--{{orderInfo}}-->
    <!--     退款订单详情 -->
    <div class="wrapper" v-if="refundOrder">
      <div class="item acea-row row-between">
        <div>Recipient:</div>
        <div class="conter">{{ orderInfo.real_name }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>Contact number:</div>
        <div class="conter">{{ orderInfo.user_phone }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>Delivery address:</div>
        <div class="conter">{{ orderInfo.user_address }}</div>
      </div>
    </div>
    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>{{$t('message.my_order.detail_total_amount')}}:</div>
        <div class="conter" v-if="orderInfo.game_state == 2">
          ₫{{ parseInt(orderInfo.up_total_price)|MoneyFormat }}
        </div>
        <div class="conter" v-else>₫{{ parseInt(orderInfo.total_price)|MoneyFormat }}</div>
      </div>
      <!--<div class="item acea-row row-between" v-if="orderInfo.coupon_price > 0">-->
      <!--<div>优惠券抵扣:</div>-->
      <!--<div class="conter">-₫{{ orderInfo.coupon_price }}</div>-->
      <!--</div>-->
      <!--<div class="item acea-row row-between" v-if="orderInfo.use_integral > 0">-->
      <!--<div>积分抵扣:</div>-->
      <!--<div class="conter">-₫{{ orderInfo.deduction_price }}</div>-->
      <!--</div>-->
      <!--<div class="item acea-row row-between" v-if="orderInfo.pay_postage > 0">-->
      <!--<div>运费:</div>-->
      <!--<div class="conter">₫{{ orderInfo.pay_postage }}</div>-->
      <!--</div>-->
      <div class="actualPay acea-row row-right">
        {{$t('message.my_order.detail_amount_paid')}}:
        <!--<span class="money font-color-red" v-if="orderInfo.game_state==2">₫{{ orderInfo.up_total_price }}</span>-->
        <span class="money font-color-red">₫{{ parseInt(orderInfo.pay_price) |MoneyFormat }}</span>
      </div>
    </div>
    <div style="height:1.6rem;" v-if="!refundOrder && offlineStatus"></div>

    <div
      class="footer acea-row row-right row-middle"
      v-if="!refundOrder && offlineStatus"
    >
      <template>
        <div
          class="bnt btn-yellow"
          @click="
            $router.push({
              path: '/detail/' + orderInfo.cartInfo[0].productInfo.id
            })
          "
        >
          {{$t('message.my_order.detail_re_order')}}
        </div>
      </template>
    </div>

    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      >
      </iframe>
    </div>
  </div>
</template>
<style scoped>
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}

.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
.btn-red {
  border: 1px solid #da2d2d;
  color: #da2d2d;
}
.btn-blue {
  border: 1px solid #00c3f9;
  color: #00c3f9;
}
.btn-gray {
  border: 1px solid #999999;
  color: #999999;
}
.btn-yellow {
  border: 1px solid #fcbb01;
  color: #fcbb01;
}
</style>
<script>
import OrderGoods from "@components/OrderGoods";
import navTitle from "@components/navTitle";
import { orderDetail } from "@api/order";
import { lottery_result } from "@api/game";
import ClipboardJS from "clipboard";
import Payment from "@components/Payment";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import {
  cancelOrderHandle,
  takeOrderHandle,
  delOrderHandle,
  payOrderHandle
} from "@libs/order";
import { wechatEvevt } from "@libs/wechat";

const NAME = "OrderDetails";

export default {
  name: NAME,
  components: {
    OrderGoods,
    Payment,
    navTitle
  },
  props: {},
  data: function() {
    return {
      offlinePayStatus: 2,
      orderTypeName: "Normal order",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {}
      },
      gameOpenData: "", //游戏开奖信息
      status: {},
      pay: false,
      payType: ["yue", "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      system_store: {},
      mapKay: "",
      mapShow: false
    };
  },
  computed: {
    refundOrder() {
      return this.orderInfo.refund_status > 0;
    },
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function() {
    this.getDetail();

    this.$nextTick(function() {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("Copy success");
      });
    });
  },
  methods: {
    getGameInfo() {
      lottery_result({
        lottery_num: this.orderInfo.game_lottery_num,
        type: this.orderInfo.game_type
      }).then(res => {
        // console.log('开奖信息',res)
        this.gameOpenData = res.data;
      });
    },
    showChang: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store._detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            // console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "Map currently unavailable"
          );
        this.mapShow = true;
      }
    },
    goBack() {
      const history = this.app.history,
        last = history[history.length - 1] || {};
      if (last.name === "MyOrder") return this.$router.go(-1);
      else return this.$router.replace({ path: "/order/list/" });
    },
    cancelOrder() {
      cancelOrderHandle(this.orderInfo.order_id)
        .then(() => {
          setTimeout(() => this.goBack(), 300);
        })
        .catch(() => {
          this.getDetail();
        });
    },
    takeOrder() {
      takeOrderHandle(this.orderInfo.order_id).finally(() => {
        this.getDetail();
      });
    },
    delOrder() {
      delOrderHandle(this.orderInfo.order_id).then(() => {
        setTimeout(() => this.goBack(), 300);
      });
    },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1 && that.orderTypeNameStatus === true) {
        that.payType.push("offline");
      }
    },
    getOrderStatus: function() {
      let orderInfo = this.orderInfo || {},
        _status = orderInfo._status || { _type: 0 },
        status = {};
      let type = parseInt(_status._type),
        delivery_type = orderInfo.delivery_type,
        seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
        bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
        combination_id = orderInfo.combination_id
          ? parseInt(orderInfo.combination_id)
          : 0;
      status = {
        type: type,
        class_status: 0
      };
      if (type === 1 && combination_id > 0) {
        status.type = 6;
        status.class_status = 1;
      } //查看拼团
      if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
      if (type === 2) status.class_status = 3; //确认收货
      if (type === 4 || type === 0) status.class_status = 4; //删除订单
      if (
        !seckill_id &&
        !bargain_id &&
        !combination_id &&
        (type === 3 || type === 4)
      )
        status.class_status = 5; //再次购买
      if (type == 9) {
        //线下付款
        status.class_status = 0;
        this.offlineStatus = false;
      }
      this.status = status;
    },
    getDetail() {
      const id = this.id;
      if (!id) return this.$dialog.error("Order not found");
      this.$dialog.loading.open("Loading...");
      orderDetail(id)
        .then(res => {
          this.orderInfo = res.data;
          this.getOrderStatus();
          if (this.orderInfo.combination_id > 0) {
            this.orderTypeName = "Spell group order";
            this.orderTypeNameStatus = false;
          } else if (this.orderInfo.bargain_id > 0) {
            this.orderTypeName = "Bargain orders";
            this.orderTypeNameStatus = false;
          } else if (this.orderInfo.seckill_id > 0) {
            this.orderTypeName = "Seconds kill order";
            this.orderTypeNameStatus = false;
          }
          this.system_store = res.data.system_store || {};
          this.mapKey = res.data.mapKey;
          if(this.orderInfo.game_state!=1)
          {
            this.getGameInfo();
          }
          this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
          this.$dialog.loading.close();
        })
        .catch(err => {
          this.$dialog.loading.close();

          this.$dialog.error(err.msg);
        });
    },
    async toPay(type) {
      var that = this;
      await payOrderHandle(this.orderInfo.order_id, type, that.from)
        .then(() => {})
        .catch(res => {
          if (res.status === "WECHAT_H5_PAY")
            that.$router.push({
              path: "/order/status/" + that.orderInfo.order_id + "/0"
            });
        });
      that.getDetail();
    }
  }
};
</script>
